import { on } from 'delegated-events';

export default (function () {
  let overlay;
  return {
    init() {
      overlay = document.querySelector('.js-overlay');

      if (overlay == null) return;

      on('click', '.js-launch-overlay', (e) => {
        e.preventDefault();
        this.open();
      });

      on('click', '.js-overlay-close', (e) => {
        e.preventDefault();
        this.close();
      });

      const autoLaunch = document.querySelector('.js-overlay.js-overlay-autolaunch');
      if (autoLaunch !== null) {
        this.open();
      }
    },
    open() {
      document.documentElement.classList.add('is-overlay-open');
      window.setTimeout(() => {
        document.querySelector('.js-overlay button, .js-overlay a').focus();
      }, 300);
    },
    close() {
      document.documentElement.classList.remove('is-overlay-open');
      if (spirax.location.locationFocusTrap !== undefined) {
        spirax.location.locationFocusTrap.unpause();
      }
      window.setTimeout(() => {
        this.resetOverlay();
      }, 300);
    },
  };
}());
